var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hasPermission('stockmanagement.view') ? _c('span', _vm._b({}, 'span', [_vm.$attrs], false), [_vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm.hasStock === true ? _c('span', {
    staticClass: "text-success"
  }, [_vm._v(" op voorraad ")]) : _vm.hasStock === false ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" geen voorraad ")]) : _c('b-button', {
    staticClass: "m-o p-0 d-inline-block",
    attrs: {
      "size": "sm",
      "variant": "link",
      "disabled": !_vm.productIdentifier.trim().length
    },
    on: {
      "click": _vm.loadStockinfo
    }
  }, [_vm._v(" controleer voorraad ")])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }